import etribeMark from '../assets/icons/etribe-blue.svg';
import { Reveal } from '../components/effects/Reveal';
import { Spotlight } from '../components/effects/Spotlight';
import { buttonVariants } from '../components/ui/Button';

const RECRUITING_URL = 'https://recruiting.etribe.consulting/';

export default function Recruiting() {
  return (
    <section id="reclutamiento" className="py-[120px] relative overflow-hidden bg-etribe-blue-dark text-white">
      {/* Background decoration */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none -z-0 opacity-70"
        style={{
          background:
            'radial-gradient(60% 50% at 0% 0%, rgba(255,200,54,.10), transparent 60%), radial-gradient(50% 40% at 100% 100%, rgba(255,255,255,.06), transparent 60%)',
        }}
      />

      {/* Logo eTribe decorativo en esquina superior derecha de la sección */}
      <img
        src={etribeMark}
        alt=""
        aria-hidden
        className="absolute -top-20 -right-20 w-[640px] h-auto opacity-[0.08] select-none pointer-events-none z-0"
        draggable={false}
      />

      <div className="container-etribe relative z-10">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr] lg:items-center">

          {/* Columna izquierda — copy + CTA */}
          <Reveal>
            <div className="max-w-[640px]">
              <p className="eyebrow text-etribe-yellow"><span>Reclutamiento</span></p>
              <h2 className="text-[clamp(32px,3.6vw,48px)] mb-5 leading-[1.1]">
                ¿Quieres formar parte del equipo?
              </h2>
              <p className="text-[clamp(17px,1.3vw,20px)] text-white/75 leading-[1.55] mb-10">
                Buscamos personas curiosas, con ganas de construir y aprender en proyectos reales de Data, Analytics e IA. Si te late la tribu, queremos conocerte.
              </p>

              <a
                href={RECRUITING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={buttonVariants({ variant: 'accent', size: 'lg' })}
              >
                Postúlate aquí
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  aria-hidden
                >
                  <path d="M7 17L17 7M9 7h8v8" />
                </svg>
              </a>

              <p className="mt-5 text-sm text-white/55">
                Te redirigiremos a nuestro portal de reclutamiento.
              </p>
            </div>
          </Reveal>

          {/* Columna derecha — bloque visual con logo de fondo y bullets */}
          <Reveal delay={120}>
            <Spotlight
              className="group relative rounded-[20px] border border-white/10 bg-white/[0.04] backdrop-blur-sm overflow-hidden transition-all duration-500 hover:border-etribe-yellow/30 hover:-translate-y-1 hover:shadow-[0_20px_50px_-10px_rgba(255,200,54,.18)]"
              color="rgba(255, 200, 54, 0.14)"
              size={520}
            >
              <div className="relative p-10">
                {/* Glow amarillo sutil en hover */}
                <span
                  aria-hidden
                  className="absolute -top-10 -right-10 w-60 h-60 rounded-full bg-etribe-yellow/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
                />

                <p className="font-heading text-[11px] tracking-[0.18em] uppercase text-etribe-yellow mb-6 font-bold relative z-10">
                  Lo que ofrecemos
                </p>

                <ul className="flex flex-col gap-5 relative z-10">
                  {[
                    'Proyectos retadores con clientes líderes en su industria',
                    'Cultura cercana, sin capas ni jerarquías innecesarias',
                    'Aprendizaje continuo en Cloud, Data e IA',
                    'Equipo diverso que se sienta al lado del cliente',
                  ].map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-3 text-[15px] text-white/85 leading-[1.55] transition-transform duration-300 hover:translate-x-1"
                    >
                      <span
                        aria-hidden
                        className="mt-1.5 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-etribe-yellow shadow-[0_0_8px_rgba(255,200,54,.6)]"
                      />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Spotlight>
          </Reveal>

        </div>
      </div>
    </section>
  );
}
